import React, { useState } from "react";
import { v4 as uuid4 } from "uuid";
import * as jwt from "jsonwebtoken";

import axios from "axios";
import jsonwebtoken from "jsonwebtoken";

export const CreateRoom = () => {
  const [name, setName] = useState("");
  const [desc, setdesc] = useState("");
  var app_access_key = "61c41ec8a0fa766d7f54283d";
  var app_secret =
    "_oLi12wcuzsuZvjOcAESa4tMX6W6oKVMw3rU0a8pzeNI4Fmb1H_6gpOi2suCpNbL4EJZUbKhKGaerb0cniPzi7YjaUHIfv-l9OCCAd72IQU19P8AvihSgcLIbUJ1sR2sevjJKdgaj0XxwEMLqIwyXbo9Rm3ukmg9NaWJCmvuciU=";

  jwt.sign(
    {
      access_key: app_access_key,
      type: "management",
      version: 2,
      iat: Math.floor(Date.now() / 1000),
      nbf: Math.floor(Date.now() / 1000),
    },
    app_secret,
    {
      algorithm: "HS256",
      expiresIn: "24h",
      jwtid: uuid4(),
    },
    function (err, token) {
      console.log(token);
    }
  );

  const headers = {
    Authorization: `Bearer  <management key>                                            eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhY2Nlc3Nfa2V5IjoiNjFjNDFlYzhhMGZhNzY2ZDdmNTQyODNkIiwidHlwZSI6Im1hbmFnZW1lbnQiLCJ2ZXJzaW9uIjoyLCJpYXQiOjE2NDExMzg2MjEsIm5iZiI6MTY0MTEzODYyMSwiZXhwIjoxNjQxMjI1MDIxLCJqdGkiOiJkMjdhOTlkZi1mNzRlLTRjYzEtYjBlNC0wZTdlZjBlY2E1YWUifQ.WB7fiBosohgM57nixsw7FGFZcp0VP6SIxEDw7k9Uv1c`,
    // "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
  };

  const handleSubmit = e => {
    e.preventDefault();
    const room = { name: name, description: desc };
    axios
      .post("https://prod-in2.100ms.live/api/v2/rooms", JSON.stringify(room), {
        headers: headers,
      })
      .then(function (response) {
        console.log(response);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  return (
    <div>
      <div className=" flex  flex-col justify-center my-8 items-center w-full h-full text-white">
        <div>
          <img className="w-36 h-12" src="https://i.imgur.com/AqfA7nS.jpg" />
        </div>
        <div className="text-3xl mb-3 p-3  border-b-2">
          MCPlatform Interactive Video Application
        </div>
      </div>
      <div className=" flex justify-center items-center w-full h-full text-white">
        <div className="bg-gray-100 text-white w-1/2 m-2 p-3  rounded-lg divide-solid">
          <div className="text-2xl mb-3 p-3  border-b-2">Create a Room</div>

          <div className="flex flex-wrap text-sm">
            <div className="w-1/3 flex justify-end items-center">
              <span>Room Name:</span>
            </div>
            <div className="p-2 w-2/3">
              <input
                className="rounded-lg bg-gray-200 w-full p-1"
                value={name}
                onChange={e => setName(e.target.value)}
              ></input>
            </div>
            <div className="w-1/3 flex justify-end items-center  ">
              <span>Description (optional):</span>
            </div>
            <div className="p-2 w-2/3">
              <input
                className="rounded-lg bg-gray-200 w-full p-1"
                value={desc}
                onChange={e => setdesc(e.target.value)}
              ></input>
            </div>
            <div className="w-full flex justify-end m-2">
              <button
                className="bg-blue-main rounded-lg px-5 py-2"
                onClick={handleSubmit}
              >
                Create
              </button>
            </div>
            <div className="w-1/3 flex justify-start items-center  ">
              <span>Host Url</span>
            </div>
            <div className="p-2 w-full">
              <input className="rounded-lg bg-gray-200 w-full p-1"></input>
            </div>
            <div className="w-1/3 flex justify-start items-center  ">
              <span>Guest Url</span>
            </div>
            <div className="p-2 w-full">
              <input className="rounded-lg bg-gray-200 w-full p-1"></input>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateRoom;
